// Wspólna etykieta typu kuponu/cart rule dla UI (koszyk, karta produktu, overlay).
//
// PrestaShop CartRule może łączyć korzyści: zniżkę procentową, zniżkę kwotową
// ORAZ darmową dostawę (free_shipping). Wcześniej trzy komponenty miały własne,
// zduplikowane `reductionLabel`, które ignorowały `freeShipping` i przy kuponie
// „tylko darmowa dostawa" pokazywały generyczne „Rabat". Tutaj składamy wszystkie
// aktywne korzyści w jedną etykietę (np. „10% taniej + darmowa dostawa").

type CouponReduction = {
  reductionPercent: number
  reductionAmount: number
  freeShipping: boolean
}

/**
 * Buduje czytelną etykietę korzyści z kuponu.
 * Pusty zestaw korzyści (np. cart rule typu „produkt gratis", którego front nie
 * modeluje) → „Rabat". Pierwsza litera jest kapitalizowana, więc sama darmowa
 * dostawa daje „Darmowa dostawa".
 */
export function formatCouponReduction(coupon: CouponReduction): string {
  const parts: string[] = []

  if (coupon.reductionPercent > 0) {
    parts.push(`${Math.round(coupon.reductionPercent)}% taniej`)
  }
  if (coupon.reductionAmount > 0) {
    parts.push(`${Math.round(coupon.reductionAmount)} zł taniej`)
  }
  if (coupon.freeShipping) {
    parts.push('darmowa dostawa')
  }

  if (parts.length === 0) {
    return 'Rabat'
  }

  const label = parts.join(' + ')
  return label.charAt(0).toUpperCase() + label.slice(1)
}
